import { Box } from '@mui/material';

import { AsideHeader, NoticeChip } from '@/components/ui';

/**
 * The right-hand rail on an area that has nothing in it yet.
 *
 * It is here so Team and Billing are shaped like Planning and Financials
 * rather than being two pages that simply lack a right-hand side. The rail
 * lands collapsed to its chevron (`Panels defaultCollapsed`), so this is what
 * someone finds when they deliberately open it — which is why it says what
 * WILL be here rather than apologising for being empty.
 *
 * One component for both areas, not one each: the two differ only in the words, and two files this similar are how `ProjectBudgetAside` and
 * `planning/SidePanel` drifted apart in the first place (ADR 0013).
 */
export type ProjectAreaAsideProps = {
  title: string;
  projectName: string;
  projectCode?: string;
  customerName?: string;
  /** One line on what this rail will total once the area exists. */
  note: string;
};

export const ProjectAreaAside = ({
  title,
  projectName,
  projectCode,
  customerName,
  note,
}: ProjectAreaAsideProps) => (
  <Box data-automation-id="project-area-aside">
    <AsideHeader title={title} meta={[projectName, projectCode, customerName]} />

    {/*
      `mt: 2` under the header, as ProjectBudgetAsideEmpty's nudge. An info
      NoticeChip (3 Nov): nothing is wrong here, and every panel's notes are
      the same chip.
    */}
    <Box sx={{ mt: 2 }}>
      <NoticeChip tone="info" icon="info" automationId="area-aside-note">
        {note}
      </NoticeChip>
    </Box>
  </Box>
);
